const fault = [
    {
        path: '/fault/record',
        name: 'faultRecord',
        component: () => import('@/view/fault/record'),
    },
]
export default fault